/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCorporationsCorporationIdKillmailsRecent200Ok
 */
export interface GetCorporationsCorporationIdKillmailsRecent200Ok {
    /**
     * A hash of this killmail
     * @type {string}
     * @memberof GetCorporationsCorporationIdKillmailsRecent200Ok
     */
    killmailHash: string;
    /**
     * ID of this killmail
     * @type {number}
     * @memberof GetCorporationsCorporationIdKillmailsRecent200Ok
     */
    killmailId: number;
}

/**
 * Check if a given object implements the GetCorporationsCorporationIdKillmailsRecent200Ok interface.
 */
export function instanceOfGetCorporationsCorporationIdKillmailsRecent200Ok(value: object): value is GetCorporationsCorporationIdKillmailsRecent200Ok {
    if (!('killmailHash' in value) || value['killmailHash'] === undefined) return false;
    if (!('killmailId' in value) || value['killmailId'] === undefined) return false;
    return true;
}

export function GetCorporationsCorporationIdKillmailsRecent200OkFromJSON(json: any): GetCorporationsCorporationIdKillmailsRecent200Ok {
    return GetCorporationsCorporationIdKillmailsRecent200OkFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdKillmailsRecent200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdKillmailsRecent200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'killmailHash': json['killmail_hash'],
        'killmailId': json['killmail_id'],
    };
}

export function GetCorporationsCorporationIdKillmailsRecent200OkToJSON(json: any): GetCorporationsCorporationIdKillmailsRecent200Ok {
    return GetCorporationsCorporationIdKillmailsRecent200OkToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdKillmailsRecent200OkToJSONTyped(value?: GetCorporationsCorporationIdKillmailsRecent200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'killmail_hash': value['killmailHash'],
        'killmail_id': value['killmailId'],
    };
}

